import * as React from "react";
import UploadPricelist from "../../components/pricing/CSVUpload";
import Typography from "@mui/material/Typography";
import InnerPage from "../../components/InnerPage";

export default function PricelistsScreen({ user }) {
  return (
    <InnerPage title="Manage Pricelists">
      <UploadPricelist user={user} />
    </InnerPage>
  );
}
